(() => {
  'use strict';
  function initialise(root) {
    if (root.dataset.b2bReady) return;
    root.dataset.b2bReady = 'true';
    const rows = root.querySelector('[data-product-rows]');
    const add = root.querySelector('[data-add-product]');
    const status = root.querySelector('[data-product-status]');
    if (!rows || !add) return;
    const prototype = rows.querySelector('[data-product-row]').cloneNode(true);
    let next = 2;
    const refresh = () => {
      const all = rows.querySelectorAll('[data-product-row]');
      all.forEach(row => { row.querySelector('[data-remove-product]').hidden = all.length === 1; });
    };
    add.hidden = false;
    add.addEventListener('click', () => {
      const number = next++;
      const row = prototype.cloneNode(true);
      row.dataset.productRow = String(number);
      row.querySelector('legend').textContent = `Producto ${number}`;
      [['[data-product-input]', 'Producto'], ['[data-quantity-input]', 'Cantidad'], ['[data-variant-input]', 'Variante']].forEach(([selector, key]) => {
        const input = row.querySelector(selector);
        input.name = `contact[${key}_${number}]`;
        input.value = key === 'Cantidad' ? '1' : '';
      });
      row.querySelector('[data-remove-product]').textContent = `Eliminar producto ${number}`;
      rows.append(row);
      refresh();
      row.querySelector('[data-product-input]').focus();
      status.textContent = `Producto ${number} añadido.`;
    });
    rows.addEventListener('click', event => {
      const remove = event.target.closest('[data-remove-product]');
      if (!remove || rows.querySelectorAll('[data-product-row]').length < 2) return;
      const row = remove.closest('[data-product-row]');
      const number = row.dataset.productRow;
      const target = row.nextElementSibling || row.previousElementSibling;
      row.remove();
      refresh();
      (target?.querySelector('[data-product-input]') || add).focus();
      status.textContent = `Producto ${number} eliminado.`;
    });
    const params = new URLSearchParams(window.location.search);
    const product = params.get('product') || params.get('product_title') || params.get('product_url');
    const variant = params.get('variant') || params.get('variant_title');
    const first = rows.querySelector('[data-product-row]');
    if (product) first.querySelector('[data-product-input]').value = product.slice(0, 1000);
    if (variant) first.querySelector('[data-variant-input]').value = variant.slice(0, 500);
    const productUrl = root.querySelector('[data-product-url]');
    const variantId = root.querySelector('[data-variant-id]');
    if (productUrl) productUrl.value = (params.get('product_url') || '').slice(0, 1000);
    if (variantId) variantId.value = (params.get('variant_id') || '').slice(0, 100);
    const quantity = Number(params.get('quantity'));
    if (Number.isSafeInteger(quantity) && quantity > 0) first.querySelector('[data-quantity-input]').value = String(quantity);
    const feedback = root.querySelector('[data-form-feedback]');
    if (feedback) feedback.focus();
  }
  const start = scope => scope.querySelectorAll('[data-ac-b2b]').forEach(initialise);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(document), { once: true });
  else start(document);
  document.addEventListener('shopify:section:load', event => start(event.target));
})();
